// SHCT-604 — the one badge that means "changed since the last PRO deployment,
// i.e. not deployed yet".
//
// Three screens rendered it with the word `수정` (PRD 04 PRO 항목 설계 tree, PRD 05
// 문항 설계 card, PRD 07 관리 지침 list) while the PRD 06 배포관리 header already said
// `변경됨` — the wording ADM.001 settled. Same state, two words, so operators read
// them as two different things: `수정` says "somebody edited an existing thing",
// which is actively wrong on an item that was just CREATED, and it never conveys
// the thing that matters, that the change is not live yet.
//
// The label lives in one place now (`common:badges.dirty`) because the three call
// sites each hard-coded their own namespace key, which is how the wording drifted
// apart in the first place. Requirement 5 of the story: next rename touches one
// string. The colour is unchanged — `badge-warning`, same as the header chip, so
// wording and colour now agree at both levels.
//
// Not this component's job: the dirty tracking itself (`deploy-dirty.store`), when
// the badge shows, or when it clears on a successful [PRO 전체 배포].

import { useTranslation } from 'react-i18next';

interface DirtyBadgeProps {
  /** Per-site spacing / sizing. The colour class is fixed on purpose. */
  style?: React.CSSProperties;
  /** Optional hover text (only the 문항 설계 card carries one today). */
  title?: string;
}

export function DirtyBadge({ style, title }: DirtyBadgeProps) {
  const { t } = useTranslation('common');
  return (
    <span className="badge badge-warning" style={style} title={title}>
      {t('badges.dirty')}
    </span>
  );
}
